// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { footerApplicationStyles } from "@sc/App/Widgets/Footer/FooterApplication";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

footerApplicationStyles.container = {
    css: css`
        display: flex;
        gap: 20px;
        align-items: center;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 16px;
            align-items: start;
        }
    `,
};

footerApplicationStyles.buttonsContainer = {
    css: css`
        display: flex;
        gap: 12px;
        align-items: center;
    `,
};

footerApplicationStyles.text = {
    color: "common.ui1",
    size: 18,
    lineHeight: "24px",
    weight: "bold",
};

footerApplicationStyles.firstButton = {
    variant: "secondary",
    css: css`
        background-color: transparent;
        border-color: ${color("common.ui1")};
        min-height: 28px;
        padding: 0 16px;
        ${TypographyStyle} {
            color: ${color("common.ui1")};
            white-space: nowrap;
            font-size: 11px;
        }
        &&&:focus,
        &&&:hover {
            background-color: transparent;
            border-color: ${color("primary.main")};
            ${TypographyStyle} {
                color: ${color("primary.main")};
            }
        }
    `,
};

footerApplicationStyles.secondButton = {
    variant: "primary",
    css: css`
        background-color: ${color("common.ui1")};
        border-color: ${color("common.ui1")};
        min-height: 28px;
        padding: 0 16px;
        ${TypographyStyle} {
            color: ${color("primary.main")};
            white-space: nowrap;
            font-size: 11px;
        }
        &&&:focus,
        &&&:hover {
            background-color: ${color("common.ui8")};
            border-color: ${color("common.ui8")};
            ${TypographyStyle} {
                color: ${color("common.ui9")};
            }
        }
    `,
};
